module.exports = __webpack_public_path__ + "bf7f40afb85d5c1ee991e8cd81a7dca1.MP3";